import React from 'react';
import { FadeIn, Section } from './Shared';
import { Droplets, Zap } from 'lucide-react';
export const MechanismSection = () => {
  return <Section bg="cream" data-id="element-167">
      <FadeIn data-id="element-168">
        <div className="text-center mb-10" data-id="element-169">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-170">
            Método D-R{' '}
            <span className="text-brand-teal font-normal" data-id="element-171">
              (Drenaje + Recarga)
            </span>
          </h2>
        </div>
      </FadeIn>

      <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto mb-10" data-id="element-172">
        <FadeIn delay={0.1} data-id="element-173">
          <div className="bg-white p-8 rounded-2xl shadow-sm border-t-4 border-brand-teal h-full" data-id="element-174">
            <div className="flex items-center gap-4 mb-6" data-id="element-175">
              <div className="bg-brand-teal/10 p-3 rounded-xl" data-id="element-176">
                <Droplets className="w-8 h-8 text-brand-teal" data-id="element-177" />
              </div>
              <div data-id="element-178">
                <h3 className="text-xl font-bold text-gray-400 uppercase tracking-wider text-sm" data-id="element-179">
                  Fase 1
                </h3>
                <h4 className="text-2xl font-bold text-brand-charcoal" data-id="element-180">
                  DRENAJE{' '}
                  <span className="text-brand-teal text-lg font-normal" data-id="element-181">
                    (Días 1–7)
                  </span>
                </h4>
              </div>
            </div>
            <ul className="space-y-4" data-id="element-182">
              <li className="flex items-start gap-3" data-id="element-183">
                <span className="text-brand-teal font-bold mt-1" data-id="element-184">•</span>
                <span className="text-lg text-gray-700" data-id="element-185">
                  Vacías toxinas y grasa acumulada
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-186">
                <span className="text-brand-teal font-bold mt-1" data-id="element-187">•</span>
                <span className="text-lg text-gray-700" data-id="element-188">
                  Reduces inflamación
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-189">
                <span className="text-brand-teal font-bold mt-1" data-id="element-190">•</span>
                <span className="text-lg text-gray-700" data-id="element-191">
                  Desinflamas el abdomen
                </span>
              </li>
            </ul>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-192">
          <div className="bg-white p-8 rounded-2xl shadow-sm border-t-4 border-brand-yellow h-full" data-id="element-193">
            <div className="flex items-center gap-4 mb-6" data-id="element-194">
              <div className="bg-brand-yellow/10 p-3 rounded-xl" data-id="element-195">
                <Zap className="w-8 h-8 text-brand-yellow" data-id="element-196" />
              </div>
              <div data-id="element-197">
                <h3 className="text-xl font-bold text-gray-400 uppercase tracking-wider text-sm" data-id="element-198">
                  Fase 2
                </h3>
                <h4 className="text-2xl font-bold text-brand-charcoal" data-id="element-199">
                  RECARGA{' '}
                  <span className="text-brand-yellow text-lg font-normal" data-id="element-200">
                    (Días 8–14)
                  </span>
                </h4>
              </div>
            </div>
            <ul className="space-y-4" data-id="element-201">
              <li className="flex items-start gap-3" data-id="element-202">
                <span className="text-brand-yellow font-bold mt-1" data-id="element-203">•</span>
                <span className="text-lg text-gray-700" data-id="element-204">
                  Reactivas la energía celular
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-205">
                <span className="text-brand-yellow font-bold mt-1" data-id="element-206">•</span>
                <span className="text-lg text-gray-700" data-id="element-207">
                  Enseñas a tu cuerpo a quemar grasa
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-208">
                <span className="text-brand-yellow font-bold mt-1" data-id="element-209">•</span>
                <span className="text-lg text-gray-700" data-id="element-210">
                  Estabilizas tu metabolismo
                </span>
              </li>
            </ul>
          </div>
        </FadeIn>
      </div>

      <FadeIn delay={0.4} data-id="element-211">
        <div className="text-center bg-white py-6 px-8 rounded-xl shadow-sm max-w-2xl mx-auto border border-gray-100" data-id="element-212">
          <p className="text-xl font-medium text-gray-700" data-id="element-213">
            <span className="font-bold text-brand-teal uppercase tracking-wide" data-id="element-214">
              Resultado:
            </span>{' '}
            tu cuerpo vuelve a funcionar correctamente.
          </p>
        </div>
      </FadeIn>
    </Section>;
};